import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { meQuery } from '@/features/auth/auth-api';
import { safeRedirect } from '@/features/auth/safe-redirect';
import { SetupTwoFactor } from '@/features/auth/setup-two-factor';

export const Route = createFileRoute('/_public/setup-2fa')({
  validateSearch: z.object({ redirect: z.string().optional() }),
  beforeLoad: async ({ context, search }) => {
    const me = await context.queryClient.query(meQuery);
    if (me === null) throw redirect({ to: '/login' });
    if (!me.twoFactorSetupRequired) throw redirect({ href: safeRedirect(search.redirect) });
  },
  component: SetupPage,
});

function SetupPage() {
  const { redirect: target } = Route.useSearch();
  return <SetupTwoFactor redirect={target} />;
}
